import { useMemo } from 'react';
import { isSuperuserSession } from '@/auth/sessionAccess';
import type { AuthSession } from '@/auth/types';
import type { NavItem } from '@/components/sidebarTypes';

export const useNavItems = (
  session: AuthSession | null,
  items: NavItem[],
  options?: { isAdmin?: boolean },
): {
  navItemsForSession: NavItem[];
  isAdminUser: (session: AuthSession | null) => boolean;
  isSuperuser: (session: AuthSession | null) => boolean;
} => {
  const isSuperuser = (s: AuthSession | null): boolean => isSuperuserSession(s);
  const isAdminUser = (s: AuthSession | null): boolean => {
    if (!s) return false;
    return options?.isAdmin === true || isSuperuser(s);
  };

  const navItemsForSession = useMemo<NavItem[]>(() => {
    return items.filter((item) => {
      if (item.requiresSuperuser) {
        return session ? isSuperuser(session) : false;
      }
      if (item.requiresAdmin) {
        return session ? isAdminUser(session) : false;
      }
      return true;
    });
  }, [items, options?.isAdmin, session]);

  return { navItemsForSession, isAdminUser, isSuperuser };
};
